import { render, staticRenderFns } from "./FriendsContext.vue?vue&type=template&id=7b656e2b"
import script from "./FriendsContext.vue?vue&type=script&lang=js"
export * from "./FriendsContext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports